import React, { useEffect, useState, useContext } from 'react';
import { Container, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Header from './Header';
import endpoints from '../constants/endpoints';
import ServiceCard from './projects/ServiceCard';
import FallbackSpinner from './FallbackSpinner';
import AppContext from '../AppContext';
import { getTranslation } from '../constants/translations';
import '../css/services.css';

const Services = ({ header }) => {
  const { language } = useContext(AppContext);
  const t = getTranslation(language);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch(endpoints.services)
      .then((res) => {
        console.log('Response status:', res.status);
        if (!res.ok) throw new Error(`Error: ${res.statusText}`);
        return res.json();
      })
      .then((data) => {
        console.log('Fetched services:', data);
        setData(data.services.filter((service) => service.translationKey !== 'electronicInvoicing'));
        setIsLoading(false);
      })
      .catch((err) => console.error('Error fetching services:', err));
  }, []);

  return (
    <>
      {isLoading ? (
        <FallbackSpinner />
      ) : (
        <div className="fade-in">
           <div className="header-container">
            <Header title={header} />
          </div>


            <Container fluid>
              {data && data.length > 0 ? (
                <Row xs={1} sm={2} md={2} lg={2} className="g-4">
                  {data.map((service, index) => (
                    <div key={index} className="fade-in">
                      <ServiceCard service={service} />
                    </div>
                  ))}
                </Row>
              ) : (
                <p>{t.services.noServices || 'No services available.'}</p>
              )}
            </Container>
          
        </div>
      )}
    </>
  );
};

Services.propTypes = {
  header: PropTypes.string.isRequired,
};

export default Services;
